import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/services/auth.service';
import { UtilisateurService } from 'src/services/utilisateur.service';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
  styleUrls: ['./auth-callback.component.scss'],
  standalone: true
})
export class AuthCallbackComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router, private utilisateurService: UtilisateurService) { }

  ngOnInit() {
    this.authService.completeAuthentication().then(() => {
      this.utilisateurService.obtenirUtilisateur(false).subscribe(res => {
        this.utilisateurService.selectionEntiteUtilisateur = res;
        console.log(this.utilisateurService.selectionEntiteUtilisateur);

        if (!this.utilisateurService.selectionEntiteUtilisateur) {
          this.router.navigate(['access-denied']);
          return;
        }

        if (this.utilisateurService.selectionEntiteUtilisateur.entiteUtilisateurs.length == 1) {
          this.utilisateurService.entiteUtilisateurSelectionnee = this.utilisateurService.selectionEntiteUtilisateur.entiteUtilisateurs[0];
          const redirectUrl = sessionStorage.getItem('redirectUrl');
          sessionStorage.removeItem('redirectUrl');
          if (redirectUrl) {
            this.router.navigateByUrl(redirectUrl);
          } else {
            this.router.navigate(['accueil']);
          }
        }
        else {
          this.router.navigate(['selection-entite']);
        }
      })
    });
  }
}
